import { apiUrl } from 'services/apiBaseUrl';
import { getActiveAuthHeaders } from 'utils/getActiveAuthHeaders';
import {
  parseFilenameFromContentDisposition,
  saveBlobDownload,
} from 'utils/ommniosignSignedZipDownload';

/**
 * Same auth + company headers as RTK baseQuery; use instead of `<a href>` so GET includes
 * `authorization` and `x-company` (browser navigations do not send them).
 */
export default async function downloadBulkMessagingZip({ formatId, bulkMessagingId }) {
  const url = apiUrl(`/v1/document-format/${formatId}/bulk-messaging/${bulkMessagingId}/download`);
  const headers = getActiveAuthHeaders();
  const res = await fetch(url, { method: 'GET', credentials: 'include', headers });
  if (!res.ok) {
    let message = res.statusText;
    const text = await res.text();
    try {
      const j = JSON.parse(text);
      message = j?.error?.message || j?.data?.message || j?.data?.error || j?.message || message;
    } catch {
      if (text) message = text;
    }
    throw new Error(message);
  }
  const filename =
    parseFilenameFromContentDisposition(res.headers.get('content-disposition')) ||
    `documents-${bulkMessagingId}.zip`;
  const blob = await res.blob();
  saveBlobDownload(blob, filename);
}
